import Carousel from "react-elastic-carousel";

import { Button } from "../../Button";
import { numberWithCommas } from "../../../utils";
import {
  SubscriptionsOfServiceTypeContainer,
  SubscriptionItem,
} from "../styled";

export const SubscriptionsOfServiceType = ({
  serviceType,
  subscriptions,
  selectedSubscription,
}) => {
  return subscriptions.length ? (
    <SubscriptionsOfServiceTypeContainer>
      <div className="title">
        <h5>{serviceType.name}</h5>
        <hr />
      </div>
      <Carousel
        isRTL
        enableAutoPlay
        pagination={false}
        showEmptySlots
        autoPlaySpeed={2000}
        itemsToScroll={3}
        itemsToShow={3}
      >
        {subscriptions.map((item) => (
          <SubscriptionItem
            onClick={() => {
              selectedSubscription(item);
            }}
            key={item.id}
          >
            <div className="head">
              <img src={item.preview} alt={item.name} />
              <h6>{item.name}</h6>
            </div>
            {item.price ? (
              <p className="price">{numberWithCommas(item.price)} تومان</p>
            ) : null}
            <Button color="blue">خرید اشتراک</Button>
          </SubscriptionItem>
        ))}
      </Carousel>
    </SubscriptionsOfServiceTypeContainer>
  ) : null;
};
